import {Privilege} from 'src/app/app.constants';

export interface Role {
  _id?: string;
  id?: string;
  displayName?: string;
  permissions?: RolePermissions;
  organizationId?: string;
  isAdminRole?: boolean;
  isSystemRole?: boolean;
}

export type RolePermissions = Record<RolePermissionOptions, RolePermissionValue>;

export enum RolePermissionOptions {
  Users = 'users',
  Teams = 'teams',
  Roles = 'roles',
  AccountAndBilling = 'accountAndBilling',
  Schedule = 'schedule',
  Exporting = 'exporting',
  Importing = 'importing',
  Projects = 'projects',
  Tasks = 'tasks',
  TasksAddRewardsToTasks = 'tasks.addRewardsToTasks',
  Rewards = 'rewards',
  Tokens = 'tokens',
  Trackers = 'trackers',
  Goals = 'goals',
  Reports = 'reports',
}

export type RolePermissionValue = {
  name: string;
  description: string;
  active: boolean;
};

export interface RoleForm {
  privileges?: Privilege[];
  displayName?: string;
}
